import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { DateTime } from 'luxon';
import { Subscription } from 'rxjs/internal/Subscription';
import { CoachingSessionDTO } from '../../dtos/coaching-session.dto';
import { CoachingLogService } from '../../services/coaching-log/coaching-log.service';
import { CURRENT_SCHOOL_YEAR } from '../../services/school-year/school-year.utilities';
import { ObsvSessionSubmissionResponse } from '../../types/responses/coaching-log.responses';
import { CoachingLogPrevSubmissionsModalComponent } from '../coaching-log-prev-submissions-modal/coaching-log-prev-submissions-modal.component';

@Component({
  selector: 'app-coaching-log-prev-submissions',
  standalone: false,
  templateUrl: './coaching-log-prev-submissions.component.html',
  styleUrl: './coaching-log-prev-submissions.component.scss',
})
export class CoachingLogPrevSubmissionsComponent implements OnInit, OnDestroy {
  @ViewChild('submissionModal')
  submissionModal: CoachingLogPrevSubmissionsModalComponent;

  @Input() prevSubmissionsActive: boolean;

  @Input() currentSession: CoachingSessionDTO;

  @Input() attendeeId: number;

  @Output() readonly hidePrevSubmissionsEvent = new EventEmitter<boolean>();

  subs: Subscription[] = [];

  sessionSubmissionsData: ObsvSessionSubmissionResponse[];

  selectedSessionSubIdx: number;

  firstDayOfSchoolYear = DateTime.fromISO(CURRENT_SCHOOL_YEAR.start_date)
    .startOf('day')
    .toSeconds();

  constructor(public coachingService: CoachingLogService) {}

  ngOnInit(): void {
    this.subs.push(
      this.coachingService
        .getPreviousObsvSessions(
          this.currentSession.creatorUserId,
          this.attendeeId,
          this.firstDayOfSchoolYear,
          this.getPriorDayEndTimestamp()
        )
        .subscribe((sessions) => {
          if (sessions && sessions.length > 0) {
            sessions = sessions.filter(
              (session) => session.type.view === 'observation'
            );
            this.getSessionSubmissionData(sessions);
          } else {
            this.sessionSubmissionsData = [];
          }
        })
    );
  }

  getPriorDayEndTimestamp(): number {
    const currentDate = new Date(this.currentSession.startDatetime * 1000);
    const priorDay = new Date(currentDate);
    priorDay.setDate(currentDate.getDate() - 1);
    priorDay.setHours(23, 59, 59, 999);
    return Math.floor(priorDay.getTime() / 1000);
  }

  togglePrevSubmissions(): void {
    this.hidePrevSubmissionsEvent.emit(true);
  }

  getSessionSubmissionData(coachlogs: CoachingSessionDTO[]) {
    const coachlogIds: number[] = [];
    coachlogs.forEach((session: CoachingSessionDTO) => {
      coachlogIds.push(session.id);
    });
    this.coachingService
      .getPrevObsvData(coachlogIds)
      .subscribe((sessionData) => {
        this.sessionSubmissionsData =
          sessionData.items as ObsvSessionSubmissionResponse[];
      });
  }

  showSubmissionModal(index: number) {
    this.selectedSessionSubIdx = index;
    this.submissionModal.modal.open();
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
    this.subs = [];
  }
}
